// A PDF fetched with the signed-in headers cannot be a bare link, so it opens as a blob URL in a new tab.
// Shared by the desktop receiving inbox and the driver's phone, which open the same unpriced delivery note.

/** A blob URL outlives the click only as long as the viewer tab needs to read it. */
export const PDF_URL_LIFETIME_MS = 60000;

/** Open `blob` (must be application/pdf) in a new tab. Throws Error('...') when it is not a PDF. */
export function openPdfBlob(blob, { what = 'The document' } = {}) {
  if (!blob || blob.type !== 'application/pdf') throw new Error(`${what} is not a PDF.`);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener';
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), PDF_URL_LIFETIME_MS);
}
